import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'np-confirm-download-pdf-excel',
  templateUrl: './confirm-download-pdf-excel.component.html',
  styleUrls: ['../common-dialog/common-dialog.component.scss']
})
export class ConfirmDownloadPdfExcelComponent implements OnInit {
  downloadReport: FormGroup;
  enableCsvOption: false;

  constructor(private fb: FormBuilder, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmDownloadPdfExcelComponent>) { }

  ngOnInit() {
    this.enableCsvOption = this.data?.enableCsvOption || false
    this.downloadReport = this.fb.group({
      downloadType: ['0']
    });
    if (this.data.consolidatedMode) {
      this.dialogRef.close('2');
    }
  }

  download() {
    this.dialogRef.close(this.downloadReport.get('downloadType').value);
  }
}
